import { createEntityAdapter } from '@reduxjs/toolkit';
import { TripLeg } from '../models/reservation.model';

const tripLegAdapter = createEntityAdapter<TripLeg>({
  // TODO: tripLegReferenceID should not be nullable, but is treated
  // as such elsewhere in the codebase. We should update this
  selectId: (tripLeg) => tripLeg.tripLegReferenceID!,
});

export { tripLegAdapter };
